import React, { useCallback, useEffect } from 'react';
import { Form, Input, Row } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ButtonActionPage } from '../../../../../atoms';
import { GRAPHICS } from '../../../../../../constants/define/translation';
import { StyledForm } from '../../../../../organisms/home/form/StyledForm';
import { CreateTextPayload } from '../../../../../../repository/mytm/text/textRepository';

interface FormAddUpdateTextProps {
  onSaveText: (values: any) => void;
  record?: CreateTextPayload;
}

export const FormAddUpdateText = (props: FormAddUpdateTextProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { onSaveText, record } = props;
  const [form] = Form.useForm();
  const onFinish = useCallback(
    values => {
      onSaveText({
        ...values,
      });
    },
    [record, onSaveText],
  );

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        keyText: record?.keyText,
        value: record?.value,
      });
    } else {
      form.resetFields();
    }
  }, [record]);

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onFinish} name="from-add-update-Text">
        <Row>
          <StyledForm span={24}>
            <div className="form-scroll">
              <Form.Item
                name="keyText"
                label={t('form.keyText')}
                rules={[{ required: true, message: t('validate.keyTextBlank') }]}
              >
                <Input placeholder={t('form.keyText')} disabled={!!record?.keyText} maxLength={255} />
              </Form.Item>
              <Form.Item
                name="value"
                label={t('form.value')}
                rules={[{ required: !(record && record.keyText), message: t('validate.value') }]}
              >
                <Input placeholder={t('form.value')} maxLength={255} />
              </Form.Item>
            </div>
            <ButtonActionPage
              text={record ? t('btnUpdate') : t('btnCreate')}
              id="1"
              className="btn-submit-form-home"
              htmlType="submit"
              icon={!record ? <FileAddOutlined /> : undefined}
            />
          </StyledForm>
        </Row>
      </Form>
    </>
  );
};
